/** No-op environment: reconnect still works via drop + backoff alone. */
export const noopEnvironment = {};
